import React from "react";

import{
    container,
    section,
    sectionCenter,
    sectionPad,
    sectionPadnone,
} from './main.module.scss'

const Section = ({sectionName, children, sectionType, sectionHigh}) => {
    var formation = false
    if (sectionType === "1") {
        formation = true
    }
    var initialsection = false
    if (sectionHigh === "1") {
        initialsection = true
    }
    return(
        <div className={`${container} ${formation ? sectionCenter : section } ${initialsection ? sectionPad : sectionPadnone  }`}>
            <h2>{sectionName}</h2>
            {children}
        </div>
    )
}

export default Section